/* eslint-disable */ 

(function siteHeader($, Drupal) {
  'use strict';

  Drupal.behaviors.siteHeader = {
    attach: (context) => {
      const mql = window.matchMedia('(max-width: 991px)');
      const toplevelItem = $('.main-menu__item--expanded > .main-menu__link', context);
      const linkbehavior = 'touchstart';
      let resizeTimer;
      let timer;

      // const allPanels = $('.accordion > dd').hide();
      // $('.accordion > dt > a').on('click', (e) => {
      //   allPanels.slideUp(); 
      //   $(this).parent().next().slideDown();
      //   alert('here');
      //   return false;
      // });
      
      //Checking for mobile for functionality of USA Banner
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        $('.link--darkergray_first').after('</br>');
        $('.blue-chevron').add('.link_second').on('click', (e) => {
          e.preventDefault();
          if ($('.blue-chevron').hasClass('fa-chevron-down')) {
            $('.blue-chevron').addClass('hidden');
            $('.link_second').addClass('hidden');
            $('#usa--banner_x').removeClass('hidden');
            $('.usa-accordion').removeClass('hidden');

          }
          else {
            $('.blue-chevron').toggleClass('fa-chevron-up fa-chevron-down');
            $('.usa-accordion').addClass('hidden');
            $('#usa--banner_x').addClass('hidden');
          }
        });
        $('.link--darkergray_first').add('#usa--banner_x').on('click', (e) => {
          if ($('.blue-chevron').hasClass('fa-chevron-down')) {
            
            $('.blue-chevron').removeClass('hidden');
            $('.link_second').removeClass('hidden');
            $('.usa-accordion').addClass('hidden');

          }
        });
      }else{
        $('.blue-chevron').add('.link_second').on('click', (e) => {
          e.preventDefault();
          
          if ($('.blue-chevron').hasClass('fa-chevron-down')) {
            $('.blue-chevron').toggleClass('fa-chevron-down fa-chevron-up');
            $('.usa-accordion').removeClass('hidden');

          }
          else {
            $('.blue-chevron').toggleClass('fa-chevron-up fa-chevron-down');
            $('.usa-accordion').addClass('hidden');
          }
        });
      }


      // Closes out main menu items
      const closeMainMenu = (menu) => {
        menu.each((index) => {
          const menuItem = menu[index];
          const menuSiblingLink = menu[index].previousElementSibling;
          if (menuItem.className.indexOf('main-menu--hidden') < 0) {
            $(menuSiblingLink).removeClass('active');
            menuItem.classList.add('main-menu--hidden');
            // Finish the loop early if menu to hide is found
            return false;
          }
        });
      };

      // Closes out mobile menu items
      const closeMobileMenu = (menu) => {
        menu.each((index) => {
          const menuItem = menu[index];
          const menuSiblingLink = menu[index].previousElementSibling;

          if (menuItem.className.indexOf('main-menu--hidden') < 0) {
            menuItem.classList.add('main-menu--hidden');
            $(menuSiblingLink).removeClass('active');
            // Finish the loop early if menu to hide is found
            return false;
          }
        });
      };

      // Calculates the menu height and pushes content based on the height
      const moveContent = (pushed, height) => {
        const main = $('main[role="main"]', context);
        const footer = $('footer[role="contentinfo"]', context);

        if (pushed) {
          main.addClass('mobile-menu--pushed');
          footer.addClass('mobile-menu--pushed');

          // Push the content down based on the height of the menu
          main.css({
            '-webkit-transform': `translate3d(0, ${height}px, 0)`,
            '-moz-transform': `translate3d(0, ${height}px, 0)`,
            transform: `translate3d(0, ${height}px, 0)`,
          });
          footer.css({
            '-webkit-transform': `translate3d(0, ${height}px, 0)`,
            '-moz-transform': `translate3d(0, ${height}px, 0)`,
            transform: `translate3d(0, ${height}px, 0)`,
          });
        }
        else {
          main.removeClass('mobile-menu--pushed');
          footer.removeClass('mobile-menu--pushed');

          // Move the content back to its original place
          main.css({
            '-webkit-transform': 'translate3d(0, 0, 0)',
            '-moz-transform': 'translate3d(0, 0, 0)',
            transform: 'translate3d(0, 0, 0)',
          });
          footer.css({
            '-webkit-transform': 'translate3d(0, 0, 0)',
            '-moz-transform': 'translate3d(0, 0, 0)',
            transform: 'translate3d(0, 0, 0)',
          });
        }
      };
      // Commented all calls to this function out on 4/11/22 for ticket NOAA-5497
      // Updates Menu Aria Attributes
      const updateMenuAttr = (obj) => {
        const expanded = $(obj).attr('aria-expanded');
        const hidden = $(obj).attr('aria-hidden');

        $(obj).attr({
          'aria-expanded': expanded === 'false' ? 'true' : 'false',
          'aria-hidden': hidden === 'true' ? 'false' : 'true',
        });
      };

      const openMainMenu = (e) => {
        e.preventDefault();
        const el = e.target;
        const targetmenu = el.nextElementSibling;
        const submenu = $('.main-menu__container--mega', context);

         // Show mega menu on initial click and hide surrounding menu
        if ($(targetmenu).hasClass('main-menu--hidden')) {
          closeMainMenu(submenu);

          $(el).addClass('active');
          $(targetmenu).removeClass('main-menu--hidden');
        }
      };

      // Opens Main Menu on mouseover in Desktop and Tablet View
      toplevelItem.add('.main-menu__container--mega').on('mouseover', (e) => {
        e.preventDefault();
        const mainmenu = $('.main-menu__container--mega', context);
        const mainMenuLink = $('.main-menu__link');
        mainMenuLink.addClass('mouseIsOver');
        mainMenuLink.removeClass('mouseNotOver');
        clearTimeout(timer);
        if (!mainmenu.length) {
          closeMainMenu(mainmenu);
        }
        else if (mainmenu.length) {
          setTimeout(() => {
            if (mainMenuLink.hasClass('mouseIsOver')) {
              openMainMenu(e);
            }
          }, 500);
        }
      }).on('mouseleave', (e) => {
        e.preventDefault();
        const mainmenu = $('.main-menu__container--mega', context);
        const mainMenuLink = $('.main-menu__link');
        mainMenuLink.addClass('mouseNotOver');
        mainMenuLink.removeClass('mouseIsOver');
        if ((!$(e.relatedTarget).hasClass('main-menu--mega main-menu--2'))) {
          timer = setTimeout(() => {
            if (mainmenu.length) {
              closeMainMenu(mainmenu, true);
            }
          }, 500);
        }
      });

      // Open Main Menu on Keyboard for accessibility})})
      toplevelItem.on('click', (e) => {
        const mainmenu = $('.main-menu__container--mega', context);
        if (!mainmenu.length) {
          closeMainMenu(mainmenu);
        }
        else {
          openMainMenu(e);
        }
      });

      // Opens Main Menu in Mobile View
      $('.site-header__menu-link', context).on('click', () => {
        const targetMenu = $(context).find('.mobile-menu__level[data-level="1"]');
        const transformHeight = targetMenu.outerHeight();

        // Show "active" style for the header link button
        $(this).toggleClass('site-header__menu-link--active');

        // Toggle Aria Attributes
       // updateMenuAttr($(this));

        // Show First Level of Mobile Menu and Push Main Content/Footer Down
        $(context).find('.mobile-menu__level[data-level="1"]').toggleClass('mobile-menu__level--open');

        // Hide the secondary menu if mobile menu is closing
        const secondarymenu = $('.mobile-menu__level[data-level="2"]', context);

        if (secondarymenu.hasClass('mobile-menu__level--open')) {
          // updateMenuAttr(secondarymenu);
          secondarymenu.removeClass('mobile-menu__level--open');
        }

        // Determine if the content has been pushed or not
        const contentPushed = $(context).find('main[role="main"]').hasClass('mobile-menu--pushed');
        moveContent(!contentPushed, transformHeight);
      });

      $('.mobile-menu__item--first > .mobile-menu__link', context).on('click', (e) => {
         // Prevent link from navigating to the node page
        e.preventDefault();
        const el = e.target;
        const targetmenu = el.nextElementSibling;
        const transformHeight = $(targetmenu).outerHeight();
        let contentPushed;

        // Show header's level 2 menu
        $(targetmenu).toggleClass('mobile-menu__level--open');

        // Toggle aria attributes
        // updateMenuAttr(targetmenu);
        // Will need to pass true since child links never closes the menu
        moveContent(true, transformHeight);
      });

      $('.mobile-menu__back .link', context).on('click', (e) => {
        e.preventDefault();
        const el = e.target;
        const targetmenu = $(el).parents('.mobile-menu__level[data-level="1"]');
        const transformHeight = targetmenu.outerHeight();

        // Hide header's level 2 menu
        $(el).parent().parent('.mobile-menu__level').removeClass('mobile-menu__level--open');

        // Will need to pass true since Back link never closes the menu
        moveContent(true, transformHeight);
      });

      // Check to see if the menu should be closed upon browser sizing
      $(window).on('resize', () => {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(() => {
          // If browser is resized to tablet/mobile view
          if (mql.matches) {
            const mainmenu = $('.main-menu__container--mega', context);
            closeMainMenu(mainmenu);
          }
          // If browser is resized to desktop view
          else {
            // Hide the secondary menu if mobile menu is closing
            const mobilemenu = $('.mobile-menu__level[data-level="1"]', context);
            const secondarymenu = $('.mobile-menu__level[data-level="2"]', context);

            if (secondarymenu.hasClass('mobile-menu__level--open')) {
              // updateMenuAttr(secondarymenu);
              secondarymenu.removeClass('mobile-menu__level--open');
            }

            if (mobilemenu.hasClass('mobile-menu__level--open')) {
              // updateMenuAttr(mobilemenu);
              mobilemenu.removeClass('mobile-menu__level--open');
            }

            // Will need to pass false since we are closing mobile menu
            moveContent(false, 0);
          }
        }, 250);
      });

      // Closes the Main Menu when you click anything other than Main Menu
      $(document).on('click', (e) => {
        if ((!$(e.target).hasClass('site-header__menu-icon')) && (!$(e.target).hasClass('site-header__menu-link')) && (!$(e.target).hasClass('link'))) {
          const mobileMenu = $(context).find('.mobile-menu__level[data-level="1"]');
          const mainmenu = $('.main-menu__container--mega', context);
          if (mainmenu.length) {
            closeMainMenu(mainmenu);
          }
          if (mobileMenu.length) {
            if ((!$(e.target).parents('#input-search-form_header-search-mobile').length) && (!$(e.target).hasClass('input-search')) && (!$(e.target).hasClass('mobile-menu__back'))) {
              // Toggle Aria Attributes
              // updateMenuAttr(mobileMenu);
              // Close First Level of Mobile Menu and Push Main Content/Footer Down
              mobileMenu.removeClass('mobile-menu__level--open');

              // Hide the secondary menu if mobile menu is closing
              const secondarymenu = $('.mobile-menu__level[data-level="2"]', context);

              if (secondarymenu.hasClass('mobile-menu__level--open')) {
                // updateMenuAttr(secondarymenu);
                secondarymenu.removeClass('mobile-menu__level--open');
              }

              // Un-push content
              const transformHeight = mobileMenu.outerHeight();
              const contentPushed = $(context).find('main[role="main"]').removeClass('mobile-menu--pushed');
              moveContent(!contentPushed, transformHeight);
            }
          }
        }
      });
    },
  };
}(jQuery, Drupal));
/* eslint-ensable */ 
